import { render, staticRenderFns } from "./WithdrawCryptoExchangeForm.vue?vue&type=template&id=05c4a25f&scoped=true"
import script from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
export * from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawCryptoExchangeForm.vue?vue&type=style&index=0&id=05c4a25f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4a25f",
  null
  
)

export default component.exports